"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL = exports.FalcorRoutes = void 0;
var FalcorRoutes;
(function (FalcorRoutes) {
    FalcorRoutes["AAB_IRO_RECOMMENDATIONS_POST"] = "aabIroRecommendationsPost";
    FalcorRoutes["ACCOUNTS"] = "accounts[{keys:id}]";
    FalcorRoutes["ACCOUNT_SELECTIONS"] = "accountSelections";
    FalcorRoutes["ACTIVE_RISK_ASSESSMENT_PRE_CHECK"] = "aabPreAraPost";
    FalcorRoutes["ACTIVE_RISK_ASSESSMENT_POST_CHECK"] = "aabPostAraPost";
    FalcorRoutes["ACTIVITY_LOG"] = "activityLog[{keys:id}]";
    FalcorRoutes["ADVICE_ACCOUNTS"] = "adviceAccounts";
    FalcorRoutes["ADVICE_ACCOUNTS_CREATE"] = "adviceAccountsCreate";
    FalcorRoutes["ADVICE_ACCOUNTS_UPDATE"] = "adviceAccountsUpdate";
    FalcorRoutes["ADVICE_ACCOUNTS_DELETE"] = "adviceAccountsDelete";
    FalcorRoutes["AGGREGATED_ACCOUNTS"] = "aggregatedAccounts[{keys:id}]";
    FalcorRoutes["AGGREGATED_ACCOUNT_DETAILS"] = "aggregatedAccountDetails[{keys:id}]";
    FalcorRoutes["AGGREGATED_ACCOUNTS_TIMESTAMP"] = "aggregatedAccountsTimestamp";
    FalcorRoutes["AGGREGATED_ACCOUNT_DELETE"] = "aggregatedAccountDelete[{keys:id}]";
    FalcorRoutes["APPOINTMENT_ELIGIBILITY"] = "appointmentEligibility";
    FalcorRoutes["APPOINTMENT_ELIGIBILITY_PRE_ENROLL"] = "appointmentEligibilityPreEnroll";
    FalcorRoutes["ANNUAL_CASHFLOW"] = "annualCashflow[{keys:id}]";
    FalcorRoutes["ATIS_GET_INFORMATION"] = "atisGetInformation";
    FalcorRoutes["ATIS_DELETE"] = "atisDelete";
    FalcorRoutes["ATIS_TRIGGER"] = "atisTrigger";
    FalcorRoutes["ATIS_TRIGGER_FORCE_REBALANCE"] = "atisTriggerForceRebalance";
    FalcorRoutes["AUTOMATIC_INVESTMENT_PLAN_GET"] = "automaticInvestmentPlanGet[{keys:accountIds}]";
    FalcorRoutes["AXE_ACCOUNTS_ADAPTER"] = "axeAccountsAdapter[{keys:id}]";
    FalcorRoutes["AXE"] = "axe";
    FalcorRoutes["BANKS"] = "banks[{keys:transactionType}]";
    FalcorRoutes["BEHAVIORAL_COACHING_ORCHESTRATOR"] = "behavioralCoachingOrchestrator";
    FalcorRoutes["BONUS"] = "bonus[{keys:id}]";
    FalcorRoutes["CALCULATE_ASSET_MIX"] = "calculateAssetMix[{keys:id}]";
    FalcorRoutes["CALCULATE_GOAL_SOLVER"] = "calculateGoalSolver[{keys:id}]";
    FalcorRoutes["CASH_IN"] = "cashIn[{keys:id}]";
    FalcorRoutes["CASHFLOW"] = "cashflow[{keys:id}]";
    FalcorRoutes["CLIENTS"] = "clients[{keys:id}]";
    FalcorRoutes["CLIENT_OFFER_DATA"] = "clientOfferData";
    FalcorRoutes["CLIENT_PREFERENCES"] = "clientPreferences";
    FalcorRoutes["CLIENT_PREFERENCES_CREATE"] = "clientPreferencesCreate";
    FalcorRoutes["CLIENT_PREFERENCES_DELETE"] = "clientPreferencesDelete";
    FalcorRoutes["CLIENT_PREFERENCES_UPDATE"] = "clientPreferencesUpdate";
    FalcorRoutes["CLIENT_PREFERENCES_TASKLIST"] = "clientPreferencesTasklist[{keys:taskListId}]";
    FalcorRoutes["CLIENT_PREFERENCES_TASKLIST_PATCH"] = "clientPreferencesTasklistPatch[{keys:taskListId}]";
    FalcorRoutes["CLIENT_PREFERENCES_TASK"] = "clientPreferencesTask[{keys:taskListId}][{keys:uuid}]";
    FalcorRoutes["CLIENT_PREFERENCES_TASK_UPDATE"] = "clientPreferencesTaskUpdate[{keys:taskListId}][{keys:uuid}]";
    FalcorRoutes["CLIENT_PREFERENCES_TASK_DELETE"] = "clientPreferencesTaskDelete[{keys:taskListId}][{keys:uuid}]";
    FalcorRoutes["CLIENT_PREFERENCES_ANALYTICS_DATA"] = "clientPreferencesAnalyticsData[{keys:analyticsDataName}]";
    FalcorRoutes["CLIENT_PREFERENCES_ANALYTICS_DATA_UPDATE"] = "clientPreferencesAnalyticsDataUpdate[{keys:analyticsDataName}]";
    FalcorRoutes["CLIENT_PREFERENCES_EXPERIENCE_VISITED"] = "clientPreferencesExperienceVisited[{keys:experienceName}]";
    FalcorRoutes["CLIENT_PREFERENCES_EXPERIENCE_VISITED_UPDATE"] = "clientPreferencesExperienceVisitedUpdate[{keys:experienceName}]";
    FalcorRoutes["COMPENSATION"] = "compensation[{keys:id}]";
    FalcorRoutes["CONSENT"] = "consent[{keys:id}]";
    FalcorRoutes["CONSENT_INFORMATION"] = "consentInformation";
    FalcorRoutes["CONTENT"] = "content[{keys:id}][{keys:themeId}]";
    FalcorRoutes["CONTRIBUTIONS_ADAPTER_SCHEDULED"] = "contributions_adapter_scheduled[{keys:id}]";
    FalcorRoutes["CONTRIBUTIONS_EXPERIMENT"] = "contributions_experiment";
    FalcorRoutes["CONTRIBUTION_LIMITS_CALCULATED"] = "contributionLimitsCalculated[{keys:currentAge}]";
    FalcorRoutes["CONTRIBUTION_MATCH_RULES"] = "contributionMatchRules[{keys:planId}]";
    FalcorRoutes["CONTRIBUTION_SUMMARIES"] = "contribution-summaries";
    FalcorRoutes["CUSTOM_AUDIENCE_RESOLVER"] = "narAudienceCheck[{keys:audienceId}][{keys:audiencePrefix}]";
    FalcorRoutes["DEBT_CALCULATOR"] = "debtCalculator[{keys:id}]";
    FalcorRoutes["DRAFT_EPI_CONFIRM"] = "draftEpiConfirm";
    FalcorRoutes["ELIGIBILITY"] = "eligibility[{keys:id}]";
    FalcorRoutes["ENROLLMENT"] = "enrollment[{keys:id}]";
    FalcorRoutes["ENROLLMENT_PUT"] = "enrollmentPut[{keys:id}]";
    FalcorRoutes["FEE_WAIVER"] = "feeWaiver";
    FalcorRoutes["FILENET_SAVE"] = "filenetSaveUtility";
    FalcorRoutes["FUNDS_AVAILABLE"] = "fundsAvailable";
    FalcorRoutes["GET_INVESTMENT_RECOMMENDATIONS_REMOVE_ACCOUNT"] = "investmentRecommendationsRemoveAccounts[{keys:removeAccountIds}][{keys:goalId}]";
    FalcorRoutes["GET_INVESTMENT_RECOMMENDATIONS"] = "getInvestmentRecommendations[{keys:goalId}]";
    FalcorRoutes["GATEKEEPER"] = "gatekeeper[{keys:id}]";
    FalcorRoutes["GOAL_SOLVER_GPO"] = "goalSolverGpo";
    FalcorRoutes["GPO_SPONSOR_PLAN_SAVINGS_CALCULATE"] = "gpoSponsorPlanSavingsCalculate";
    FalcorRoutes["HOUSEHOLD_DEMOGRAPHICS_GET_EDUCATION_LEVELS"] = "householdDemographicsGetEducationLevels";
    FalcorRoutes["HOUSEHOLD_DEMOGRAPHICS_GET_OCCUPATIONS"] = "householdDemographicsGetOccupations";
    FalcorRoutes["HOUSEHOLD_DEMOGRAPHICS_GET_INDUSTRIES"] = "householdDemographicsGetIndustries";
    FalcorRoutes["HOUSEHOLD_DEMOGRAPHICS_POST_DEMOGRAPHICS"] = "householdDemographicsPostDemographics";
    FalcorRoutes["HOUSEHOLD_DEMOGRAPHICS_GET_DEMOGRAPHICS"] = "householdDemographicsGetDemographics";
    FalcorRoutes["INBOUND_CLIENT_DATA_ADAPTER_CARDS"] = "inboundClientDataAdapterCards";
    FalcorRoutes["INDIVIDUAL_CONTRIBUTION_LIMITS"] = "individual-contribution-limits[{keys:id}]";
    FalcorRoutes["INST_CLIENT_ADDRESS"] = "instClientAddress[{keys:id}]";
    FalcorRoutes["INST_PLAN_DEMOGRAPHICS"] = "instPlanDemographics[{keys:id}]";
    FalcorRoutes["UPDATE_MANAGED_ACCOUNTS"] = "updateManagedAccounts[{keys:id}]";
    FalcorRoutes["MANUALLY_ENTERED_ACCOUNTS"] = "manuallyEnteredAccounts[{keys:id}]";
    FalcorRoutes["MANUALLY_ENTERED_ACCOUNTS_UPDATE"] = "manuallyEnteredAccountsUpdate[{keys:id}]";
    FalcorRoutes["MANUALLY_ENTERED_ACCOUNTS_SAVE"] = "manuallyEnteredAccountsSave[{keys:id}]";
    FalcorRoutes["MANUALLY_ENTERED_ACCOUNT_DELETE"] = "manuallyEnteredAccountDelete[{keys:id}]";
    FalcorRoutes["MEASUREMENT_AS_A_SERVICE"] = "maas";
    FalcorRoutes["MUNI_TAX_BRACKET_PREFERENCE"] = "muniTaxBracketPreference";
    FalcorRoutes["NON_ELECTIVE_CONTRIBUTIONS_TEXT"] = "nonElectiveContributionsText[{keys:planId}]";
    FalcorRoutes["OFFBOARD"] = "offboard[{keys:id}]";
    FalcorRoutes["OFFER_ELIGIBILITY"] = "offerEligibility[{keys:offerType}]";
    FalcorRoutes["COMPLETE_OFFBOARD"] = "completeOffboard[{keys:id}]";
    FalcorRoutes["OUTSIDE_HOLDINGS_DB"] = "outsideHoldingsDB[{keys:id}]";
    FalcorRoutes["OUTSIDE_HOLDINGS_DB_TRADITIONAL"] = "outsideHoldingsDBTraditional[{keys:id}]";
    FalcorRoutes["OUTSIDE_HOLDINGS_HSA"] = "outsideHoldingHSA[{keys:id}]";
    FalcorRoutes["OUTSIDE_HOLDINGS_NQP"] = "outsideHoldingsNQP";
    FalcorRoutes["ONE_TIME_WITHDRAWAL"] = "oneTimeWithdrawal[{keys:goalId}][{keys:accountId}][{keys:amount}]";
    FalcorRoutes["PARTICIPANT_SUBSCRIPTIONS"] = "participantSubscriptions[{keys:id}]";
    FalcorRoutes["MULTI_GOAL_ALLOCATOR"] = "multiGoalAllocator[{keys:provideBalances}]";
    FalcorRoutes["MULTI_GOAL_CALCULATE"] = "multiGoalCalculate";
    FalcorRoutes["PCA_ESG_ACCESS"] = "pcaESGAccess";
    FalcorRoutes["PCA_PORTFOLIO_TYPE"] = "portfolioType";
    FalcorRoutes["PLAN_CONTRIBUTIONS"] = "sponsorPlanContributions";
    FalcorRoutes["PLAN_CONTRIBUTIONS_CREATE"] = "sponsorPlanContributionsCreate";
    FalcorRoutes["PLAN_CONTRIBUTIONS_UPDATE"] = "sponsorPlanContributionsUpdate";
    FalcorRoutes["PLAN_CONTRIBUTIONS_DELETE"] = "sponsorPlanContributionsDelete";
    FalcorRoutes["PLAN_INVESTMENTS"] = "planInvestments[{keys:id}][{keys:fundType}]";
    FalcorRoutes["PORTFOLIO_CREATE"] = "portfolioCreate[{keys:id}]";
    FalcorRoutes["PORTFOLIO_GET"] = "portfolioGet[{keys:id}]";
    FalcorRoutes["PORTFOLIO_UPDATE"] = "portfolioUpdate[{keys:id}]";
    FalcorRoutes["PROFILE"] = "profile";
    FalcorRoutes["PROFILE_POST"] = "profilePost";
    FalcorRoutes["PROFILE_PUT"] = "profilePut";
    FalcorRoutes["PROFILE_DELETE"] = "profileDelete";
    FalcorRoutes["PROFILE_DELETE_INCOME"] = "profileDeleteIncome";
    FalcorRoutes["PROFILE_MULTI_GOAL"] = "profileMultiGoal";
    FalcorRoutes["RESOURCE_CENTER"] = "resourceCenter";
    FalcorRoutes["RESTRICT_FEATURE"] = "restrictFeature[{keys:accountsLength}][{keys:isEnrollButton}]";
    FalcorRoutes["RETIREMENT_DATA_UPDATE"] = "retirementDataUpdate";
    FalcorRoutes["RISK_ATTITUDE"] = "riskAttitude";
    FalcorRoutes["RISK_TOKEN"] = "riskToken";
    FalcorRoutes["SMN_GET_GAIN_LOSS"] = "smnGetGainLoss";
    FalcorRoutes["SOCIAL_SECURITY"] = "socialSecurity[{keys:id}]";
    FalcorRoutes["SOCIAL_SECURITY_OPTIMIZE"] = "socialSecurityOptimize[{keys:id}]";
    FalcorRoutes["STATES_TERRITORIES"] = "statesTerritories";
    FalcorRoutes["SWITCH_OFFER"] = "switchOffer[{keys:offerType}]";
    FalcorRoutes["CHANGE_OFFER"] = "changeOffer[{keys:offerType}]";
    FalcorRoutes["TRANSITION_OFFER"] = "transitionOffer[{keys:offerType}][{keys:offerStatus}]";
    FalcorRoutes["TAX_BRACKET_PREFERENCE"] = "taxBracketPreference[{keys:id}]";
    FalcorRoutes["TAX_LOSS_OPTION"] = "taxLossOption";
    FalcorRoutes["TAX_LOSS_OPTION_ELIGIBILITY"] = "taxLossOptionEligibility";
    FalcorRoutes["TAX_RATES"] = "taxRates";
    FalcorRoutes["TRADES"] = "trades[{keys:id}]";
    FalcorRoutes["TRANSACTION_HISTORY_ADAPTER"] = "transaction_history_adapter[{keys:id}]";
    FalcorRoutes["UNREGISTER_USER"] = "unregisterUser[{keys:id}]";
    FalcorRoutes["URL"] = "url[{keys:id}]";
    FalcorRoutes["YODLEE_RELATIONSHIP"] = "yodleeRelationship";
    FalcorRoutes["WITHDRAWAL_ELIGIBILITY"] = "withdrawal_eligibility[{keys:id}]";
})(FalcorRoutes = exports.FalcorRoutes || (exports.FalcorRoutes = {}));
exports.ALL = ['ALL'];
